import {ApiAxiosInstance, create} from "@/helpers/api";

export const platform: ApiAxiosInstance = create();

export default platform